import {StorageService} from "./StorageService";
import {EKind, ITimeEntryTypeVm, ProxyContainer} from '../Data/Data';
import {LogoutService} from "./LogoutService";

export class TimeEntryDataService {

  static serviceId = "timeEntryData";
  static $inject = [
    '$proxy',
    StorageService.serviceId,
    LogoutService.serviceId,
  ];

  constructor(private proxy: ProxyContainer,
              private storage: StorageService,
              private logout: LogoutService) {

  }

  create() {
    return this.proxy.TimeBooking.newTimeBookingDetailVm();
  }

  async getDefault(kind: EKind) {
    const types = await this.getEntryTypes();

    return types.filter(t => t.kind === kind)
      .sort((a,b) => a.externalId - b.externalId)[0];
  }

  async getEntryType(id: number) {
    const entryTypes = await this.getEntryTypes();
    for(const entryType of entryTypes) {
      if(entryType.id === id) {
        return entryType;
      }
    }
    return null;
  }

  async loadEntryTypes() {
    try {
      const entries = await this.logout.catchLogoutResponse(this.proxy.TimeEntrtyType.getTimeEntryTypesMultiple({}));
      this.storage.setTimeEntryTypes(entries.data);
      console.log('timeentries loaded');
      return entries.data;
    } catch (e) {
      console.log('failed to fetch entry types');
    }
    return [];
  }

  async getEntryTypes(): Promise<ITimeEntryTypeVm[]> {
    if (this.storage.hasTimeEntryTypes()) {
      return this.storage.getTimeEntryTypes();
    }

    return this.loadEntryTypes();
  }
}
